import { Avatar, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TypePlantas } from "../../pages/home/interace/frigorifico.interface";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import imagePlanta from './images/iconodiac1.jpg'

type CardProps = {
    propsPlanta: TypePlantas;
}

export const PlantaComponent: React.FC<CardProps> = ({propsPlanta}) => {
    let navigate = useNavigate();
    return (
        <Paper
        elevation={4}
        sx={{
            borderRadius: 3,
            overflow: "hidden",
            mb: 2,
            p: 1,
        }}
        >
        <List disablePadding>
            <ListItem disablePadding>
            <ListItemButton
                onClick={() => navigate("/frigorificos", { state: propsPlanta })}
                sx={{
                borderRadius: 2,
                "&:hover": {
                    backgroundColor: "primary.main",
                    color: "white",
                    "& .MuiAvatar-root": {
                    border: "2px solid white",
                    },
                    "& .MuiSvgIcon-root": {
                    color: "white",
                    },
                },
                }}
            >
                {/* Avatar del frigorífico */}
                <ListItemAvatar>
                <Avatar
                    alt="Plantas"
                    src={imagePlanta}
                    sx={{ width: 48, height: 48, mr: 1 }}
                />
                </ListItemAvatar>

                {/* Texto principal */}
                <ListItemText
                primary={
                    <Typography variant="subtitle1" fontWeight="bold">
                    {propsPlanta.name_front}
                    </Typography>
                }
                secondary={
                    <Typography variant="body2" color="text.secondary">
                    {propsPlanta.ubicacion || "Ubicación desconocida"}
                    </Typography>
                }
                />

                {/* Icono de navegación */}
                <ListItemIcon sx={{ minWidth: 32 }}>
                <NavigateNextIcon />
                </ListItemIcon>
            </ListItemButton>
            </ListItem>
        </List>
        </Paper>
            )
}

